import { Box, Typography, Card, CardContent } from "@mui/material";
import FadeInBox from "../../commonComponents/FadeInBox";
import header from "../../assets/hero.png";
import heroMobile from "../../assets/heroMob.png";

const About = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#FBFBFB",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Hero Banner Section */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: { xs: 5, md: 8 },
        }}
      >
        <Box
          component="img"
          alt="About El Deeb"
          src={window.innerWidth < 768 ? heroMobile : header}
          sx={{
            width: "100%",
            height: { xs: "300px", md: "400px" },
            objectFit: "cover",
            display: "block",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(to right, rgba(22, 75, 124, 0.7) 20%, rgba(22, 75, 124, 0.4) 60%, rgba(22, 75, 124, 0) 70%)",
            zIndex: 0.5,
            pointerEvents: "none",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: { xs: "50%", md: "30%" },
            transform: "translate(-50%, -50%)",
            color: "#FFFFFF",
            width: { xs: "85%", md: "70%", lg: "50%" },
            zIndex: 1,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <FadeInBox delay={0.2}>
            <Typography
              sx={{
                fontSize: { xs: "24px", sm: "32px", md: "42px", lg: "48px" },
                fontWeight: 700,
                fontFamily: "Montserrat",
                mb: { xs: 2, md: 3 },
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              }}
            >
              Your trusted partner in medical and commercial supply
            </Typography>
          </FadeInBox>
        </Box>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          ml: { xs: 2, md: 15 },
          mr: { xs: 2, md: 15 },
          pb: { xs: 5, md: 10 },
        }}
      >
        {/* Company Overview Section */}
        <FadeInBox delay={0.2} triggerOnScroll={true} triggerOnMount={false}>
          <Box sx={{ mb: { xs: 6, md: 8 } }}>
            <Typography
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "28px", md: "36px" },
                color: "#164B7C",
                fontFamily: "Montserrat",
                mb: { xs: 4, md: 5 },
                textAlign: "center",
              }}
            >
              Who We Are
            </Typography>
            <Card
              sx={{
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                borderRadius: "12px",
                p: { xs: 3, md: 4 },
                backgroundColor: "#FFFFFF",
              }}
            >
              <CardContent sx={{ p: 0 }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "18px", md: "22px" },
                    fontFamily: "Montserrat",
                    color: "#164B7C",
                    mb: { xs: 2, md: 3 },
                  }}
                >
                  El Deeb for Import, Export & Trade Agencies Limited
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: "15px", md: "18px" },
                    fontFamily: "Montserrat",
                    lineHeight: 1.8,
                    color: "#333333",
                    mb: { xs: 3, md: 4 },
                  }}
                >
                  We are a UK-registered import, export, and trading agency
                  specializing in the supply of medical and commercial products.
                  Operating as a trading and distribution agency, we connect
                  healthcare manufacturers, hospitals, clinics, and distributors
                  through a strong network of local and international partners
                  across the United Kingdom and global markets.
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: "15px", md: "18px" },
                    fontFamily: "Montserrat",
                    lineHeight: 1.8,
                    color: "#333333",
                  }}
                >
                  We work closely with trusted manufacturers to ensure quality,
                  compliance, and efficiency throughout every stage of the
                  supply chain — from sourcing and negotiation to coordination,
                  documentation, and delivery.
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </FadeInBox>

        {/* What We Offer Section */}
        <FadeInBox delay={0.3} triggerOnScroll={true} triggerOnMount={false}>
          <Box sx={{ mb: { xs: 6, md: 8 } }}>
            <Typography
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "28px", md: "36px" },
                color: "#164B7C",
                fontFamily: "Montserrat",
                mb: { xs: 4, md: 5 },
                textAlign: "center",
              }}
            >
              Our Portfolio
            </Typography>
            <Card
              sx={{
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                borderRadius: "12px",
                p: { xs: 3, md: 4 },
                backgroundColor: "#FFFFFF",
              }}
            >
              <CardContent sx={{ p: 0 }}>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: "15px", md: "18px" },
                    fontFamily: "Montserrat",
                    lineHeight: 1.8,
                    color: "#333333",
                  }}
                >
                  Our portfolio includes medical disposables, devices, and
                  refurbished equipment, along with a wide range of commercial
                  products. All products are sourced and supplied under strict
                  quality and compliance standards, ensuring that our partners
                  receive only the highest quality goods.
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </FadeInBox>

        {/* Commitment Section */}
        <FadeInBox delay={0.4} triggerOnScroll={true} triggerOnMount={false}>
          <Box sx={{ mb: { xs: 6, md: 8 } }}>
            <Card
              sx={{
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                borderRadius: "12px",
                p: { xs: 3, md: 4 },
                backgroundColor: "#164B7C",
                color: "#FFFFFF",
              }}
            >
              <CardContent sx={{ p: 0 }}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: "22px", md: "28px" },
                    fontFamily: "Montserrat",
                    mb: { xs: 2, md: 3 },
                  }}
                >
                  Our Commitment
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: "15px", md: "18px" },
                    fontFamily: "Montserrat",
                    lineHeight: 1.8,
                    color: "#FFFFFF",
                  }}
                >
                  At El Deeb UK, we are committed to delivering certified
                  products, building sustainable trade relationships, and
                  expanding the United Kingdom's role as a global hub for
                  trusted supply and distribution.
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </FadeInBox>

        {/* Mission & Vision Section */}
        <FadeInBox delay={0.5} triggerOnScroll={true} triggerOnMount={false}>
          <Box>
            <Typography
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "28px", md: "36px" },
                color: "#164B7C",
                fontFamily: "Montserrat",
                mb: { xs: 4, md: 5 },
                textAlign: "center",
              }}
            >
              Mission & Vision
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: { xs: 3, md: 4 },
              }}
            >
              {/* Mission Card */}
              <Card
                sx={{
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  borderRadius: "12px",
                  p: { xs: 3, md: 4 },
                  backgroundColor: "#FFFFFF",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition:
                    "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.15)",
                  },
                }}
              >
                <CardContent sx={{ p: 0, flexGrow: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: "20px", md: "24px" },
                      color: "#164B7C",
                      fontFamily: "Montserrat",
                      mb: { xs: 2, md: 3 },
                    }}
                  >
                    Mission
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: "15px", md: "18px" },
                      fontFamily: "Montserrat",
                      lineHeight: 1.8,
                      color: "#333333",
                    }}
                  >
                    At El Deeb, our mission is to deliver certified medical and
                    commercial products through UK-led trade, distribution, and
                    global partnerships.
                  </Typography>
                </CardContent>
              </Card>

              {/* Vision Card */}
              <Card
                sx={{
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  borderRadius: "12px",
                  p: { xs: 3, md: 4 },
                  backgroundColor: "#FFFFFF",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition:
                    "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.15)",
                  },
                }}
              >
                <CardContent sx={{ p: 0, flexGrow: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: "20px", md: "24px" },
                      color: "#164B7C",
                      fontFamily: "Montserrat",
                      mb: { xs: 2, md: 3 },
                    }}
                  >
                    Vision
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: "15px", md: "18px" },
                      fontFamily: "Montserrat",
                      lineHeight: 1.8,
                      color: "#333333",
                    }}
                  >
                    We aim to strengthen the United Kingdom's role in
                    international healthcare and commercial supply, building a
                    trusted network that values quality, compliance, and
                    long-term collaboration.
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          </Box>
        </FadeInBox>
      </Box>
    </Box>
  );
};

export default About;
